var exports = {
  "s": "CharacterCountAnnouncer.module__srOnly___Z2gzVE",
};

module.exports = exports;
